import React from "react";
import { Container } from "../../components/styled/styled-components";
import Button, { ButtonType } from "../../components/Button/Button";
import { OrderUploaderProvider, useOrderUploaderContext } from "./context/OrderUploaderContext";
import UploadButton from "./UploadButton";
import ImportTable from "./ImportTable";
import AddToCart from "./addToCart";
import BannerInfo from "./BannerInfo";
import Toast from "../../components/Toast/Toast";
import ModalSwitcher from "./ModalSwitcher";

/**
 * OrderUploader Content Component
 *
 * The main content component that uses the OrderUploader context.
 */
const OrderUploaderContent: React.FC = () => {
  const {
    // State
    fetchedProducts,
    toast,
    isLoading,

    // Actions
    handleFileUpload,
    setToast,
  } = useOrderUploaderContext();

  const hasProducts = fetchedProducts && fetchedProducts.length > 0;
  const showUploadButton = !hasProducts;

  return (
    <Container margin="1em 0" className="order-uploader">
      {/* Template information banner */}
      <BannerInfo />

      <div className="uploader">
        {/* Add to cart button - shown when products are loaded */}
        {hasProducts && <AddToCart />}

        {/* Upload button - shown when no products are loaded */}
        {showUploadButton && (
          <UploadButton onUploadFileSubmit={handleFileUpload} isLoading={isLoading} />
        )}

        {/* Reset button */}
        <div className="util">
          <Button
            type={ButtonType.secondary}
            onClick={() => window.history.go(0)}
            disabled={isLoading}
          >
            Reset
          </Button>
        </div>
      </div>

      {/* Import table - shown when products are loaded */}
      {hasProducts && <ImportTable />}

      {/* Modal switcher for various states */}
      <ModalSwitcher />

      {/* Toast notifications */}
      <Toast content={toast} onClick={() => setToast(null)} />
    </Container>
  );
};

/**
 * OrderUploader Component
 *
 * Handles the upload and processing of CSV files containing order items.
 * Wrapped with OrderUploaderProvider to provide context to child components.
 */
const OrderUploader: React.FC = () => (
  <OrderUploaderProvider>
    <OrderUploaderContent />
  </OrderUploaderProvider>
);

export default OrderUploader;
